import React, { useMemo } from 'react'
import { useVisibleDevices } from '@data/device/device'
import ValveOperation from '@components/main/ValvesManagement/components/ValvesManager'
import { useAuthStore } from '@store/auth.store'

const DeviceStatus: React.FC = () => {
  const devices = useVisibleDevices()
  const permissions = useAuthStore((state) => state.permissions)


  const valveDevices = useMemo(() => {
    return devices.filter((device) => device.model === '3V004')
  }, [devices])

  return (
    <div id="valves-management">
      <ValveOperation
        devices={valveDevices}
        permissions={permissions}
      />
    </div>
  )
}

export default DeviceStatus
